// save the data to localStorage
export const saveDataToStorage = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data));
};

// Get data from localStorage
export const getDataFromStorage = (key) => {
  const storedData = localStorage.getItem(key);
  return storedData ? JSON.parse(storedData) : null;
};

// Remove data from localStorage
export const removeDataFromStorage = (key) => {
  localStorage.removeItem(key);
};

// Clear all data from localStorage
export const clearAllDataFromStorage = () => {
  localStorage.clear();
};

// Clear all data from localStorage
export const clearAllDataFromSessionStorage = () => {
  sessionStorage.clear();
};
